import { useState } from "react";
import { ERROR_MESSAGES, ITEMS_PER_PAGE } from "../../../constant/constant";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { useAxios } from "../../../utils/useAxios";

export const useGetTeachers = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { axiosInstance } = useAxios();

  const [teachers, setTeachers] = useState(undefined);
  const [metaData, setMetaData] = useState(undefined);

  /**
   * Fetch teachers with pagination
   */
  const getTeachers = async (
    page = 1,
    per_page = ITEMS_PER_PAGE,
    append = false,
    search = "",
  ) => {
    setLoading(true);
    setError("");

    try {
      const query = new URLSearchParams();
      query.append("page", page.toString());
      query.append("per_page", per_page.toString());

      if (search) {
        query.append("filter[search]", search);
      }

      const url = `${TENANT_DOMAIN}/school/admin/teachers?${query.toString()}`;
      const response = await axiosInstance.get(url);

      const data = response.data.data || [];
      const meta = response.data.meta || null;

      setTeachers((prev) => {
        if (!append || page === 1 || !prev) {
          return data;
        }
        return [...prev, ...data];
      });

      setMetaData(meta);


      return {
        success: true,
        data,
        meta,
      };
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN;

      setTeachers(null);
      setMetaData(null);
      setError(errorMessage);

      return {
        success: false,
        data: [],
        meta: null,
        error: errorMessage,
      };
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, teachers, getTeachers, metaData };
};
